import React, { useState, useEffect, useCallback } from "react";
import styles from "./ListingHeader.module.scss";
import Search from "../../header/CustomSearch";
import Button from "../button";
import $ from "jquery";
import "daterangepicker";
import "daterangepicker/daterangepicker.css";
import {
  AddIconSvg,
  CalendarIcon,
  ColumnTripleIcon,
  Cross,
  FilterIconSvg,
  KanbanIcon,
  ListingIcon,
  MeetingsClockIcon,
  RegularArrowDownIcon,
  SearchIcon,
} from "../../../modules/default-svg";
import CustomPopover from "../../popover/Popover";
import CheckboxInputStateSave from "../checkboxStateSave/CheckboxStateSave";
import { projects } from "../../../store/selectors/projects.selector";
import { getProjects } from "../../../store/actions/projects.actions";
import { connect, useDispatch } from "react-redux";
import IconInput from "../input/iconInput/IconInput";
import ExportButton from "../../Export/ExportButton";
import api from "../../../store/services/user.service";
import { generalActions } from "../../../store/actions";
import { debounce } from "lodash";
import searchService from "../../../store/services/search.service";
import { useRef } from "react";
import moment from "moment";
import {
  columnMappings,
  useColumnConfig,
} from "../tables/ColumnConfigProvider";
import CalendarReportButton from "../../Export/CalendarReportButton";

const ListingHeader = (props) => {
  const {
    parentType = "",
    type,
    btnLable,
    handleKanbanView,
    handleListingView,
    kanbanView,
    searchedData,
    setIsCreate,
    rightPane,
    projectId,
    programId,
    portfolioId,
    scopeId,
    clientId,
    filterRegistry,
    isHeader,
    allProjects,
    healthData,
    severityFilter,
    isCreatable,
    handleCreateFunc,
    isCalendarView,
    setIsCalendarView,
    isSearchDisable,
    triggerSearch,
  } = props;
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [project, setProject] = useState({ name: "All Projects", id: "all" });
  const [projects, setProjects] = useState([]);
  const [openPopover, setIsOpenPopover] = useState();
  const [filterValue, setFilterValue] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [setting] = useState(settings);
  const dispatch = useDispatch();
  const { tableName, updateColumnConfig } = useColumnConfig();
  const [columnConfig, setColumnConfig] = useState([]);
  const [tempColumnConfig, setTempColumnConfig] = useState([]);

  useEffect(() => {
    if (columnConfig && columnConfig.length > 0) {
      setTempColumnConfig(columnConfig);
    }
  }, [columnConfig]);

  const fetchTableLayouts = () => {
    const columns = columnMappings[tableName];
    const config = columns.map((item) => ({
      columnId: item.columnId,
      label: item.label,
      customName: item.customName ?? "",
      order: item.order ?? 0,
      isSortable: item.isSortable ?? false,
      isVisible: item.isVisible ?? true,
      accessorKey: item.accessorKey ?? "",
      columnType: item.columnType ?? "",
    }));
    try {
      api.getUserLayoutRequest(tableName).then((response) => {
        if (response?.columns?.length) {
          const config = columns.map((item) => ({
            columnId: item.columnId,
            label: item.label,
            customName:
              response.columns.find((col) => col.name === item.label)
                ?.customName ?? "",
            order:
              response.columns.find((col) => col.name === item.label)?.order ??
              0,
            isSortable: item.isSortable ?? false,
            isVisible:
              response.columns.find((col) => col.name === item.label)
                ?.isVisible ?? true,
            accessorKey: item.accessorKey ?? "",
            columnType: item.columnType ?? "",
          }));
          setColumnConfig(config);
        } else {
          setColumnConfig(config);
        }
      });
    } catch (error) {
      console.error("Error fetching table layouts:", error);
      setColumnConfig(config);
    }
  };

  useEffect(() => {
    // if (isPopoverOpen) {
    fetchTableLayouts();
    // }
  }, [isPopoverOpen, tableName]);

  const handleLabelChange = (columnId, newLabel) => {
    const customColumns = tempColumnConfig.map((col) =>
      col.columnId === columnId ? { ...col, customName: newLabel } : col
    );
    setTempColumnConfig(customColumns);
  };

  const handleCalendarView = () => {
    setIsCalendarView(!isCalendarView);
    if (!isCalendarView) {
      setIsPopoverOpen(false);
    }
  };

  // function getChangedItems(saved, updated) {
  //   const changedItems = updated.filter((updatedItem, index) => {
  //     const savedItem = saved[index];
  //     if (!savedItem) return true;
  //     return Object.keys(updatedItem).some(
  //       (key) =>
  //         JSON.stringify(updatedItem[key]) !== JSON.stringify(savedItem[key])
  //     );
  //   });

  //   return changedItems;
  // }

  const handleColumnsChange = (id) => {
    const newColumnConfig = tempColumnConfig.map((col) => {
      if (col.label === id) {
        return {
          ...col,
          isVisible: !col.isVisible,
        };
      }
      return col;
    });
    setTempColumnConfig(newColumnConfig);
    const updatedColumns = newColumnConfig.map((col) => ({
      name: col.label,
      customName: col.customName ?? "",
      order: col.order,
      isVisible: col.isVisible,
    }));

    const payload = {
      Name: tableName,
      Columns: updatedColumns,
    };
    api
      .putUserLayoutRequest(payload)
      .then((res) => {
        updateColumnConfig(newColumnConfig);
      })
      .catch((err) => {
        dispatch(
          generalActions.showToast({
            title: "Error updating column status",
            type: "error",
          })
        );
      })
      .finally(() => {
        fetchTableLayouts();
      });
  };

  const handleSaveChanges = () => {
    // const changedItems = getChangedItems(columnConfig, tempColumnConfig);
    // if (changedItems.length > 0) {
    const updatedColumns = tempColumnConfig.map((col) => ({
      name: col.label,
      customName: col.customName ?? "",
      order: col.order,
      isVisible: col.isVisible,
    }));

    const payload = {
      Name: tableName,
      Columns: updatedColumns,
    };

    // setIsPopoverOpen(false);
    api
      .putUserLayoutRequest(payload)
      .then(() => {
        updateColumnConfig(tempColumnConfig);
      })
      .catch((err) => {
        dispatch(
          generalActions.showToast({
            title: "Error updating column name",
            type: "error",
          })
        );
      })
      .finally(() => {
        fetchTableLayouts();
      });
    // } else {
    //   setIsPopoverOpen(false);
    // }
  };

  const handleResetChanges = () => {
    const payload = {
      Name: tableName,
      Columns: null,
    };

    setIsPopoverOpen(false);
    api
      .putUserLayoutRequest(payload)
      .then(() => {
        updateColumnConfig(
          tempColumnConfig.map((col) => ({
            ...col,
            isVisible: true,
          }))
        );
      })
      .catch((err) => {
        dispatch(
          generalActions.showToast({
            title: "Error on ressting columns",
            type: "error",
          })
        );
      })
      .finally(() => {
        fetchTableLayouts();
      });
  };

  const handleCreate = () => {
    setIsCreate && setIsCreate(true);
  };


  const getReportParentId = () => {
    switch (parentType) {
      case "Client":
        return clientId;
      case "Portfolio":
        return portfolioId;
      case "Program":
        return programId;
      case "Project":
        return projectId;

      default:
        return null;
    }
  };

  const getPermission = () => {
    const permissions = localStorage.getItem("permissions");
    if (permissions) {
      switch (type) {
        case "Budget":
          return permissions.includes("CostItem.Create") ? true : false;
        case "Communication Plan":
          return permissions.includes("CommunicationPlan.Create")
            ? true
            : false;
        case "Risk":
          return permissions.includes("Risk.Create") ? true : false;
        case "Change Request":
          return permissions.includes("ChangeRequest.Create") ? true : false;
        case "Scope":
          return permissions.includes("Scope.Create") ? true : false;
        case "Milestone":
          return permissions.includes("Scope.Create") ? true : false;
        case "Tasks":
          return permissions.includes("Task.Create") ? true : false;
        case "Portfolio":
          return permissions.includes("Portfolio.Create") ? true : false;
        case "Program":
          return permissions.includes("Program.Create") ? true : false;
        case "Project":
          return permissions.includes("Project.Create") ? true : false;
        case "Shift":
          return permissions.includes("Shift.Create") ? true : false;
        case "PurchaseOrder":
          return permissions.includes("PurchaseOrder.Create") ? true : false;
        case "InvoiceRegistry":
          return permissions.includes("InvoiceEntry.Create") ? true : false;
        case "Decision":
          return permissions.includes("Decision.Create") ? true : false;
        case "Runbook":
          return permissions.includes("Runbook.Create") ? true : false;
        case "ReshuffleRequest":
          return permissions.includes("Project.Create") ? true : false;
        default:
          return "";
      }
    }
  };

  useEffect(() => {
    const handleDateChange = (start, end) => {
      let startDate = moment(start).utc().format();
      let endDate = moment(end).utc().format();
      const data = {
        startDate: startDate,
        endDate: endDate,
      };
      filterRegistry && filterRegistry(data);
      setStart(startDate);
      setEnd(endDate);
    };

    const dateFormat = setting.regionalSettings.dateFormat.replace(/dd/g, 'DD').replace(/yy/g, 'YY').replace(/mm/g, 'MM');
    $("input[name='datetimes']").daterangepicker(
      {
        startDate: moment().startOf("month").format(dateFormat),
        endDate: moment().endOf("month").format(dateFormat),
        locale: {
          format: dateFormat,
        },
      },
      handleDateChange
    );

    return () => {
      $("input[name='datetimes']").daterangepicker("destroy");
    };
  }, []);

  const handleChangeProject = (project) => {
    setProject(project);
    setIsOpenPopover(null);
    const data = {
      startDate: start,
      endDate: end,
      projectId: project.id,
    };
    filterRegistry && filterRegistry(data);
  };

  const getExportConfig = () => {
    let config = {};
    switch (parentType) {
      case "Portfolio":
        config = { parent: 1, parentId: portfolioId };
        break;
      case "Program":
        config = { parent: 2, parentId: programId };
        break;
      case "Project":
        config = { parent: 3, parentId: projectId };
        break;
      case "Scope":
        config = { parent: 4, parentId: scopeId };
        break;
      default:
        break;
    }

    switch (type) {
      case "Budget":
        config = { ...config, category: 0 }
        break;
      case "PurchaseOrder":
        config = { ...config, category: 2 }
        break;
      case "InvoiceRegistry":
        config = { ...config, category: 3 }
        break;
      case "Runbook":
        config = { ...config, category: 4 }
        break;
      case "Scope":
      case "Tasks":
        config = { ...config, category: 5 }
        break;
      default:
        break;
    }

    return config;
  };

  const sortedColumnConfig = [...tempColumnConfig].sort(
    (a, b) => a.order - b.order
  );

  const projectSearchdebounced = useRef(debounce((value) => searchProjectsHandler(value), 500));

  const handleProjectSearch = useCallback((value) => {
    projectSearchdebounced.current(value);
  }, []);

  const searchProjectsHandler = (term) => {
    searchService
      .Projects(term)
      .then((res) => {
        setProjects([{ name: "All Projects", id: "all" }, ...res]);
      })
      .catch(() => {
        setProjects([]);
      });
  };

  const handleProjects = () => {
    handleProjectSearch("");
    setIsOpenPopover("projects");
  }

  return (
    <div className={styles.listingHeader}>
      <div className={styles.searchFilterWrapper}>
        {type !== "Budget" &&
          (
            <>
              <Search
                parentType={parentType}
                type={type}
                searchResult={searchedData}
                clientId={clientId}
                portfolioId={portfolioId}
                programId={programId}
                projectId={projectId}
                scopeId={scopeId}
                healthData={healthData}
                severityFilter={severityFilter}
                isDisabled={!isSearchDisable}
                triggerSearch={triggerSearch}
              />
              {type === "MeetingRegistry" && (
                <CustomPopover
                  width={"364px"}
                  icon={
                    <Button
                      btnClass="ProjectSelect text-sm-600 subHeading-color"
                      label={
                        project.name.length > 12
                          ? `${project.name.substring(0, 8)}..`
                          : project.name
                      }
                      rightIcon={
                        <span className="ms-1 d-inline-flex">
                          <RegularArrowDownIcon />
                        </span>
                      }
                      clickHandler={handleProjects}
                    />
                  }
                  status={openPopover === "projects"}
                >
                  <div className="d-flex flex-column gap-3">
                    <div className="d-flex justify-content-between align-items-center  ">
                      <h6 className=" ">Filter by projects</h6>
                      <div onClick={() => setIsOpenPopover(null)}>
                        <Cross />
                      </div>
                    </div>
                    <div>
                      <IconInput
                        icon={<SearchIcon />}
                        placeholder={"Search"}
                        handleChange={handleProjectSearch}
                      />
                    </div>
                    <div style={{ height: "176px", overflow: "auto" }}>
                      <div className="d-flex flex-wrap gap-2">
                        {projects
                          .map((p) => (
                            <span
                              className={`${styles.projectItem} ${p.id == "all" ? styles.allProjectsItem : (project.id === p.id ? styles.selectedProjectItem : '')}`}
                              value={p.id}
                              onClick={() => {
                                handleChangeProject(p);
                              }}
                            >
                              {p.name}
                            </span>
                          ))}
                      </div>
                    </div>
                  </div>
                </CustomPopover>
              )}
              <div className={`${styles.filterWrapper} text-sm-600 ms-2`}>
                <span className="me-1">
                  <FilterIconSvg />
                </span>
                Filter
              </div>
            </>
          )
        }

        {type === "MeetingRegistry" && (
          <div className={styles.rangeDateWrapper}>
            <input
              type="text"
              className={styles.rangeDateInput}
              name="datetimes"
            />
            <CalendarIcon />
          </div>
        )}
        {parentType !== "Budget" && (type === "Budget" || type === "InvoiceRegistry" || type === "PurchaseOrder" || type === "Runbook" || type === "Scope" || type === "Tasks") && (
          <div className="">
            <ExportButton config={getExportConfig()} />
          </div>
        )}
      </div>
      {rightPane && (
        <div className="d-flex align-items-center">
          {type === "Communication Plan" && (
            <div className="flex gap-1 mr-3">
              {
                parentType !== "Communications" &&
                <CalendarReportButton
                  parent={parentType}
                  parentId={getReportParentId()}
                />
              }

              <Button
                btnClass={`d_btn ms-12 d_btn_primary ${styles.commViewButton}`}
                icon={<ColumnTripleIcon color="#342c82" />}
                label="Calendar View"
                clickHandler={handleCalendarView}
              />
            </div>
          )}
          {type !== "Tasks" && (
            <CustomPopover
              icon={
                <Button
                  btnClass="d_btn d_btn_dualIconXsm"
                  rightIcon={
                    <span className="columnBadge ms-1">
                      {parentType === "Budget" ||
                        parentType === "Communications" ||
                        parentType === "Risk" ||
                        parentType === "Change Request" ||
                        parentType === "Scope" ||
                        parentType === "PurchaseOrders"
                        ? sortedColumnConfig.filter((col) => col.isVisible)
                          .length
                        : type === "MeetingRegistry" ||
                          type === "Client" ||
                          type === "Portfolio" ||
                          type === "Program" ||
                          type === "Project"
                          ? sortedColumnConfig.filter((col) => col.isVisible)
                            .length
                          : sortedColumnConfig.filter((col) => col.isVisible)
                            .length}
                    </span>
                  }
                  icon={<ColumnTripleIcon />}
                  label="Select Columns"
                />
              }
              status={isPopoverOpen}
              onOpenChange={(e, data) => {
                setIsPopoverOpen(data.open);
              }}
            >
              <div className="d-flex flex-col gap-1 relative overflow-auto max-h-[272px]">
                {parentType === "Client"
                  ? sortedColumnConfig.map((item) => (
                    <CheckboxInputStateSave
                      tableName={tableName}
                      columnId={item.columnId}
                      label={item.label}
                      parentType={parentType}
                      isColumnConfig={true}
                      customName={item.customName}
                      checked={item.isVisible}
                      onChange={() => handleColumnsChange(item.label)}
                      onLabelChange={(newLabel) =>
                        handleLabelChange(item.columnId, newLabel)
                      }
                      onSaveChanges={handleSaveChanges}
                    />
                  ))
                  : parentType === "Portfolio"
                    ? sortedColumnConfig.map((item) => (
                      <CheckboxInputStateSave
                        tableName={tableName}
                        columnId={item.columnId}
                        label={item.label}
                        parentType={parentType}
                        isColumnConfig={true}
                        customName={item.customName}
                        checked={item.isVisible}
                        onChange={() => handleColumnsChange(item.label)}
                        onLabelChange={(newLabel) =>
                          handleLabelChange(item.columnId, newLabel)
                        }
                        onSaveChanges={handleSaveChanges}
                      />
                    ))
                    : parentType === "Program"
                      ? sortedColumnConfig.map((item) => (
                        <CheckboxInputStateSave
                          tableName={tableName}
                          columnId={item.columnId}
                          label={item.label}
                          parentType={parentType}
                          isColumnConfig={true}
                          customName={item.customName}
                          checked={item.isVisible}
                          onChange={() => handleColumnsChange(item.label)}
                          onLabelChange={(newLabel) =>
                            handleLabelChange(item.columnId, newLabel)
                          }
                          onSaveChanges={handleSaveChanges}
                        />
                      ))
                      : parentType === "Project"
                        ? sortedColumnConfig.map((item) => (
                          <CheckboxInputStateSave
                            tableName={tableName}
                            columnId={item.columnId}
                            label={item.label}
                            parentType={parentType}
                            isColumnConfig={true}
                            customName={item.customName}
                            checked={item.isVisible}
                            onChange={() => handleColumnsChange(item.label)}
                            onLabelChange={(newLabel) =>
                              handleLabelChange(item.columnId, newLabel)
                            }
                            onSaveChanges={handleSaveChanges}
                          />
                        ))
                        : type === "MeetingRegistry"
                          ? sortedColumnConfig.map((item) => (
                            <CheckboxInputStateSave
                              tableName={tableName}
                              columnId={item.columnId}
                              label={item.label}
                              type={type}
                              isColumnConfig={true}
                              customName={item.customName}
                              checked={item.isVisible}
                              onChange={() => handleColumnsChange(item.label)}
                              onLabelChange={(newLabel) =>
                                handleLabelChange(item.columnId, newLabel)
                              }
                              onSaveChanges={handleSaveChanges}
                            />
                          ))
                          : type === "Decision"
                            ? sortedColumnConfig.map((item) => (
                              <CheckboxInputStateSave
                                tableName={tableName}
                                columnId={item.columnId}
                                label={item.label}
                                type={type}
                                parentType={parentType}
                                isColumnConfig={true}
                                customName={item.customName}
                                checked={item.isVisible}
                                onChange={() => handleColumnsChange(item.label)}
                                onLabelChange={(newLabel) =>
                                  handleLabelChange(item.columnId, newLabel)
                                }
                                onSaveChanges={handleSaveChanges}
                              />
                            ))
                            : sortedColumnConfig.map((item) => (
                              <CheckboxInputStateSave
                                tableName={tableName}
                                columnId={item.columnId}
                                label={item.label}
                                type={type}
                                parentType={parentType}
                                isColumnConfig={true}
                                customName={item.customName}
                                checked={item.isVisible}
                                onChange={() => handleColumnsChange(item.label)}
                                onLabelChange={(newLabel) =>
                                  handleLabelChange(item.columnId, newLabel)
                                }
                                onSaveChanges={handleSaveChanges}
                              />
                            ))}
                <div
                  className="d-flex justify-content-end mt-2 sticky bottom-0 pt-[12px] bg-white"
                  style={{ borderTop: "1px solid #e5e5e5" }}
                >
                  <Button
                    label="Reset Columns"
                    btnClass="d_btn d_btn_primary me-10"
                    clickHandler={handleResetChanges}
                  />
                  <Button
                    label="Cancel"
                    btnClass="d_btn d_btn_smallWhite"
                    btnType="secondary"
                    clickHandler={() => setIsPopoverOpen(false)}
                  />
                </div>
              </div>
            </CustomPopover>
          )}
          {type === "Tasks" && (
            <div className="flex gap-2">
              <div className={styles.taskBtnWrap}>
                <Button
                  btnClass={
                    kanbanView
                      ? `${styles.taskBtn} ${styles.taskBtn_kanban} ${styles.active}`
                      : `${styles.taskBtn} ${styles.taskBtn_kanban}`
                  }
                  clickHandler={handleKanbanView}
                  icon={<KanbanIcon />}
                />
                <Button
                  btnClass={
                    !kanbanView
                      ? `${styles.taskBtn} ${styles.taskBtn_list} ${styles.active}`
                      : `${styles.taskBtn} ${styles.taskBtn_list}`
                  }
                  clickHandler={handleListingView}
                  icon={<ListingIcon />}
                />
              </div>
              {
                !kanbanView &&
                <CustomPopover
                  icon={
                    <Button
                      btnClass="d_btn d_btn_dualIconXsm"
                      rightIcon={
                        <span className="columnBadge ms-1">
                          {
                            sortedColumnConfig.filter((col) => col.isVisible)
                              .length
                          }
                        </span>
                      }
                      icon={<ColumnTripleIcon />}
                      label="Select Columns"
                    />
                  }
                  status={isPopoverOpen}
                  onOpenChange={(e, data) => setIsPopoverOpen(data.open)}
                >
                  <div className="d-flex flex-col gap-1">
                    {sortedColumnConfig.map((item) => (
                      <CheckboxInputStateSave
                        columnId={item.columnId}
                        label={item.label}
                        type={type}
                        parentType={parentType}
                        isColumnConfig={true}
                        customName={item.customName}
                        checked={item.isVisible}
                        onChange={() => handleColumnsChange(item.label)}
                        onLabelChange={(newLabel) =>
                          handleLabelChange(item.columnId, newLabel)
                        }
                        onSaveChanges={handleSaveChanges}
                      />
                    ))}
                  </div>
                </CustomPopover>
              }

            </div>
          )}
          {!isHeader && getPermission() && (
            <Button
              btnClass="d_btn d_btn_primary ms-12 cursor-pointer"
              icon={<AddIconSvg />}
              label={btnLable}
              clickHandler={handleCreate}
            />
          )}

          {type === "Scope-Tasks" && (
            <Button
              btnClass="d_btn d_btn_primary ms-12 cursor-pointer"
              icon={<AddIconSvg />}
              label={btnLable}
              clickHandler={handleCreate}
            />
          )}

          {/* {isCreatable && ( */}
          {false && ( // Enforcing to false untill we revisit teh inline creation/update
            <Button
              btnClass="d_btn d_btn_primary ms-12"
              icon={<AddIconSvg />}
              label="Add Row"
              clickHandler={handleCreateFunc}
            />
          )}
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = {
  getProjectsRequest: getProjects,
};

const mapStateToProps = (state) => {
  const allProjects = projects(state);
  return { allProjects };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListingHeader);
